import Interview from './Interview';
import Sliderbar from './Sliderbar';

export { Interview, Sliderbar };



// WEBPACK FOOTER //
// ./src/comparison-predefined/components/index.js